import { render, staticRenderFns } from "./WebcamPanel.vue?vue&type=template&id=5e1203ff&scoped=true"
import script from "./WebcamPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./WebcamPanel.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./WebcamPanel.vue?vue&type=style&index=0&id=5e1203ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e1203ff",
  null
  
)

export default component.exports